/** Non-secret runtime configuration emitted by the backend at /config.js. */

type RuntimeConfig = {
  apiBaseUrl?: string;
  allowedUser?: string;
  environment?: string;
};

declare global {
  interface Window {
    __KORENET_CONFIG__?: RuntimeConfig;
  }
}

function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    throw new Error(
      `Missing required frontend configuration '${name}'. The application cannot start ` +
        `without a complete Microsoft Entra configuration.`,
    );
  }
  return value.trim();
}

const runtime = window.__KORENET_CONFIG__;

export const appConfig = {
  apiBaseUrl: required('apiBaseUrl', runtime?.apiBaseUrl).replace(/\/+$/, ''),
  allowedUser: required('allowedUser', runtime?.allowedUser),
  environment: (runtime?.environment ?? 'Production').trim(),
} as const;
